import { SITE_URL } from './site';

export const HOME_SEO = {
  title: 'INVERT — Restaurant TV Content & Talk to Your TV',
  description:
    'Talk to your TV, display what you want. INVERT delivers restaurant TV content and a restaurant TV box so venues update menus, specials, and promotions instantly.',
  path: '/',
};

export const FOR_BUSINESS_SEO = {
  title: 'Restaurant TV Box & Digital Signage for Businesses | INVERT',
  description:
    'Install the INVERT restaurant TV box on your existing TVs. Create restaurant TV content by typing — menus, happy hour, hiring, and daily specials update every screen.',
  path: '/for-business',
};

export const RESTAURANT_TV_SEO = {
  title: 'Restaurant TV Content & Restaurant TV Box | INVERT',
  description:
    'Looking for restaurant TV content or a restaurant TV box? INVERT turns any TV into an AI menu board. Type specials, menus, and promotions — every restaurant screen updates instantly.',
  path: '/restaurant-tv',
};

export const PRODUCT_SEO = {
  title: 'AI Restaurant TV Content Platform | INVERT Product',
  description:
    'INVERT is the AI platform for restaurant TV content. Type what you want on your restaurant TV box or Smart TV — menus, specials, and promotions appear automatically.',
  path: '/product',
};

export const PRICING_SEO = {
  title: 'Restaurant TV Content Pricing | INVERT',
  description:
    'Simple pricing for restaurant TV content and the INVERT restaurant TV box. Start free, update every screen by typing, and earn from unused ad time.',
  path: '/pricing',
};

export const APPLICATIONS_SEO = {
  title: 'Restaurant Menu Boards, Specials & Hiring Screens | INVERT',
  description:
    'Restaurant TV content for menus, daily specials, happy hour, hiring, and events. One platform updates every display in your venue.',
  path: '/applications',
};

export const PROOF_SEO = {
  title: 'Restaurant Partners & Live Screen Network | INVERT',
  description:
    'See real restaurants and venues running INVERT restaurant TV content across Los Angeles. Live screens, real installs, real results.',
  path: '/proof',
};

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'INVERT',
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    description:
      'INVERT provides restaurant TV content and restaurant TV box hardware so venues can update every screen by typing.',
    sameAs: [],
  };
}

export function buildSoftwareJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'INVERT Restaurant TV',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Android TV, Fire TV, Smart TV, INVERT TV Box',
    url: `${SITE_URL}/restaurant-tv`,
    description:
      'Restaurant TV content platform and restaurant TV box. Type menus, specials, and promotions — INVERT designs and displays them on every screen.',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Start free for venues and restaurants',
    },
  };
}

export function buildFaqJsonLd(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}
